interface DurationTranslator {
  (key: 'create.createForm.settings.duration.option.auto'): string;
  (key: 'create.createForm.settings.duration.option.text', values: { time: number }): string;
}

export const formatDurationText = (duration: number | undefined, t: DurationTranslator, fallback = '4s'): string => {
  if (duration == null || duration === 0) {
    return fallback;
  }

  if (duration === -1) {
    return t('create.createForm.settings.duration.option.auto');
  }

  return t('create.createForm.settings.duration.option.text', { time: duration });
};
